import Vue from 'vue'
import Router from 'vue-router'
import swal from 'sweetalert'
import axios from 'axios'

const routerOptions = [
    { path: '/form_conn', component: 'form_conn' },
    { path: '/', component: 'accueil' },
    { path: '/accueil', component: 'accueil' },
    { path: '/distr-ele', component: 'distribuer-eleve' },
    { path: '/distr-cla', component: 'distribuer-classe' },
    { path: '/distr-ens', component: 'distribuer-enseignant' },
    { path: '/gerer-fourniture', component: 'fourniture-gerer' },
    { path: '/nouvelle-fourniture', component: 'fourniture-nouveau' },
    { path: '/modifier-fourniture/:id', component: 'fourniture-modifier' },
    { path: '/gerer-categorie', component: 'categorie-gerer' },
    { path: '/nouvelle-categorie', component: 'categorie-nouveau' },
    { path: '/modifier-categorie/:id', component: 'categorie-modifier' },
    { path: '/inv-ele', component: 'inventaire-eleve' },
    { path: '/TEST', component: 'TEST' },
    { path: '/inv-ens', component: 'inventaire-enseignant' }
]

const routes = routerOptions.map(route => {
    return {
        path: route.path,
        component: () => import(`@/components/${route.component}.vue`)
    }
})


Vue.use(Router)

export default new Router({
  mode: 'history',
  routes
})




// WEBPACK FOOTER //
// ./src/router/index.js